<script setup>
import RaMenu from '@/layouts/components/RaMenu.vue'
</script>

<template>
  <div class="ra-page">
    <div class="content-wrapper">
      <RaMenu />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ra-page {
  min-height: 100vh;
  background-color: rgb(var(--v-theme-surface));
}

.content-wrapper {
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
